import { render, staticRenderFns } from "./VideoUploadStep3.vue?vue&type=template&id=4b32f59a&scoped=true&"
import script from "./VideoUploadStep3.vue?vue&type=script&lang=js&"
export * from "./VideoUploadStep3.vue?vue&type=script&lang=js&"
import style0 from "./VideoUploadStep3.vue?vue&type=style&index=0&id=4b32f59a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b32f59a",
  null
  
)

export default component.exports